import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { initialStatePrintHistoryFooters } from "../defaultState";
import { getPrintHistoryFooters } from "../../aplApi/printHistoryFootersHelper";
import { ReduxStatePrintHistoryFooters } from "../../types/redux/reduxStatePrintHistoryFooters";

export const printHistoryFootersApi = createAsyncThunk(
    "printHistoryFooters/footers",
    async (siteId: number) => (await getPrintHistoryFooters(siteId)).data
);

const printHistoryFooters = createSlice({
    name: "printHistoryFooters",
    initialState: initialStatePrintHistoryFooters,
    reducers: {
        onClearPrintHistoryFooters: () => initialStatePrintHistoryFooters
    },
    extraReducers: builder => {
        builder
            .addCase(printHistoryFootersApi.pending, state => {
                return {
                    ...state,
                    printHistoryFootersLoading: true,
                    printHistoryFootersErrorMessage: ""
                } as ReduxStatePrintHistoryFooters;
            })
            .addCase(printHistoryFootersApi.fulfilled, (state, action) => {
                return {
                    printHistoryFootersLoading: false,
                    printHistoryFootersErrorMessage: "",
                    printHistoryFooters: action.payload
                } as ReduxStatePrintHistoryFooters;
            })
            .addCase(printHistoryFootersApi.rejected, (state, action) => {
                return {
                    printHistoryFooters: [],
                    printHistoryFootersLoading: false,
                    printHistoryFootersErrorMessage: action.error.message ?? "API error"
                } as ReduxStatePrintHistoryFooters;
            });
    }
});

export const { onClearPrintHistoryFooters } =
    printHistoryFooters.actions;
export default printHistoryFooters.reducer;
